import { ImageCardCtaStyle } from './image-card-cta.style';
import { ChevronRight } from '@exploration/shared-components';
import { ButtonLinkProps } from '@exploration/shared-types';
import { desktopBreakpoint } from '@thrivent/midwest-shared';
import { ImageProps } from 'next/image';

// --------------------------------------------------------------------------

const {
  Section,
  Container,
  Card,
  ImageContainer,
  Image,
  ContentContainer,
  Title,
  Description,
  Button,
} = ImageCardCtaStyle;

// --------------------------------------------------------------------------

export interface ImageCardCtaProps {
  className?: string;
  image: ImageProps;
  title: string;
  description: string;
  button?: ButtonLinkProps;
  id?: string;
}

// --------------------------------------------------------------------------

export const ImageCardCta = ({
  className,
  image,
  title,
  description,
  button,
  id,
}: ImageCardCtaProps) => {
  return (
    <Section id={id} className={className}>
      <Container>
        <Card>
          <ImageContainer>
            <Image
              {...image}
              fill
              priority
              quality={100}
              sizes={`(max-width: ${desktopBreakpoint}px) 100vw, 40vw`}
            />
          </ImageContainer>
          <ContentContainer>
            <Title as="h2">{title}</Title>
            <Description as="p">{description}</Description>
            {!!button && (
              <Button href={button.href ?? '#'}>
                {button.text}
                <ChevronRight />
              </Button>
            )}
          </ContentContainer>
        </Card>
      </Container>
    </Section>
  );
};
